import { useAppSelector } from 'store/hooks';
import { selectIsAudioOnlyMode } from 'features/application/applicationSlice';
import {
  selectRemoteBroadcastingState,
  selectRemoteStreams,
} from 'features/streaming/streamingSlice';
import StreamMedia from 'features/streaming/components/stream-display/StreamMedia';
import { StreamingMediaProps } from 'features/streaming/types';
import RemoteVideoWrapper from 'features/streaming/components/media/remote-stream/RemoteVideoWrapper';
import { memo, useMemo } from 'react';

const RemoteMedia = memo(({ source, avatarSize }: StreamingMediaProps) => {
  const streams = useAppSelector((state) =>
    selectRemoteStreams(state, source.userId, source.feedId)
  );

  const audioOnlyMode = useAppSelector(selectIsAudioOnlyMode);

  const isVideoBroadcasting = useAppSelector((state) =>
    selectRemoteBroadcastingState(state, source.userId, 'video')
  );

  const showVideo = isVideoBroadcasting && !audioOnlyMode;

  const videoStreamExist = useMemo(
    () => showVideo && streams?.some((s) => s.kind === 'video'),
    [streams, showVideo]
  );

  return (
    <StreamMedia source={source} avatarSize={avatarSize} hideAvatar={videoStreamExist}>
      {streams?.map((stream) =>
        stream.kind === 'video' && showVideo ? (
          <RemoteVideoWrapper
            key={stream.mid}
            mid={stream.mid}
            userId={source.userId}
            mode="media"
          />
        ) : null
      )}
    </StreamMedia>
  );
});

export default RemoteMedia;
